<ng-container *transloco="let convert;">
  <app-modal tabindex="-1" [modalId]="'form-tracking-modal'" [labelledby]="'form-tracking-modal'"
    class="form-tracking-modal"
    (keydown.escape)="close()">
    <!--      Begin Modal Layout Containers-->
    @if (formTrackingData) {
      <ng-content *ngTemplateOutlet="formTrackingTemplate"></ng-content>
    }
    <ng-container>
      <ng-content *ngTemplateOutlet="buttons"></ng-content>
    </ng-container>
    <!--      End Modal Layout Containers-->
    <!--      Begin Templates -->
    <!--      Begin Form Tracking Template -->
    <ng-template #formTrackingTemplate>
      <ng-container>
        <div class="modal-close-container text-end">
          <button
            id="form-tracking-modal-close"
            class="modal__close"
            aria-label="Close modal"
            (click)="close()"
            data-track-elem="icon"
            data-track-name="close"
            data-track-trigger="close"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
        <header class="modal__header pb-3 d-block">
          <h4 class="modal__title mb-0 fw-bold" tabindex="-1"
            [innerHTML]="convert('sellModule.posting.newPosting.formTrackingModal.title')">
          </h4>
        </header>
        <!-- Main modal content -->
        @if (formTrackingData) {
          <div class="modal__content text-start">
            @if (formTrackingData && formTrackingData.length > 0) {
              <p class="subtitle-text">{{convert('sellModule.posting.newPosting.formTrackingModal.subtitle')}}</p>
              @for (postingFormTrackingSection of formTrackingData; track postingFormTrackingSection; let oddIndex = $odd) {
                @if (postingFormTrackingSection.displayInFormTrackingModal) {
                  <div class="postingFormSection"
                    [ngClass]="{'alt-row-background': oddIndex}">
                    <h5>{{convert(postingFormTrackingSection.translationKey)}}</h5>
                    <ul class="form-list">
                      @for (form of postingFormTrackingSection.forms; track form) {
                        @if (!form.viewed) {
                          <li>{{convert(form.translationKey)}}</li>
                        }
                      }
                    </ul>
                  </div>
                }
              }
              <p class="verification-text">{{convert('sellModule.posting.newPosting.formTrackingModal.verificationText')}}</p>
            }
          </div>
        }
      </ng-container>
    </ng-template>
    <!-- Begin button templates-->
    <ng-template #buttons>
      @if (formTrackingData) {
        <div class="decode-success-buttons d-flex flex-column flex-lg-row lg-justify-content-start mb-2">
          <button class="btn btn-primary btn-continue" (click)="continueWithPost()"
            [attr.aria-label]="convert('common.btnContinue')" data-track-name="Yes, Post">
            {{convert('sellModule.posting.newPosting.formTrackingModal.postConfirmation')}}
          </button>
          <button class="btn btn-link outline-focus" (click)="close()" data-track-name="Cancel"
            [attr.aria-label]="convert('common.btnCancel')">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      }
      @if (!formTrackingData) {
        <div class="error-buttons d-flex flex-column flex-lg-row justify-content-center mb-2">
          <button class="btn btn-primary btn-close" data-track-name="Close" (click)="close()" [attr.aria-label]="convert('common.btnClose')">
            {{convert('common.btnClose')}}
          </button>
        </div>
      }
    </ng-template>
    <!--      End Templates -->
  </app-modal>
</ng-container>
